import { Component, ChangeDetectionStrategy, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  HrpSelectComponent,
  HrpSelectOptionComponent,
  HrpSelectSearchbarComponent,
  ParFormFieldComponent,
} from '@shared/ui';
import { SearchPipe } from '@shared/utils';
import { DynamicFormControlMetadata, DynamicFormControlOption } from '@shared/dynamic-form';
import { DynamicFormControlDirective } from '../../dynamic-form-control.directive';
import { AbstractDynamicFormControl } from '../../abstact-dynamic-form-control.directive';

@Component({
  selector: 'dynamic-form-select-control',
  templateUrl: 'select-control.component.html',
  styleUrls: ['select-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    ParFormFieldComponent,
    HrpSelectComponent,
    HrpSelectOptionComponent,
    HrpSelectSearchbarComponent,
    SearchPipe,
  ],
  providers: [
    {
      provide: DynamicFormControlDirective,
      useExisting: DynamicFormSelectControlComponent,
    },
  ],
})
export class DynamicFormSelectControlComponent extends AbstractDynamicFormControl {
  private readonly stringCompareObject = signal({
    valueChange: 'valueChange',
  } as const).asReadonly();

  displayNameFn = (options: DynamicFormControlOption[]) => (selected: string) =>
    options?.find((o) => o.value === selected)?.key ?? selected;

  getValueChangeEvent({
    meta,
    event,
  }: {
    meta: DynamicFormControlMetadata<unknown>;
    event: Event;
  }) {
    const valueChangeAction = meta.actions?.find(
      (a) => a.key === this.stringCompareObject().valueChange,
    );
    if (event) {
      return valueChangeAction?.actionCallbackFn(event);
    }
  }
}
